import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import { useGetExperiment } from '../../../experiments/hooks'
import { EXPERIMENT_NAME_MARKETPLACE_HARMONISATION_PDP } from '../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../experiments/model/EXPERIMENT_VARIATION'
import {
  ProductVolumePricingModal,
  useProductVolumePricingContext,
} from '../../../product'
import { ProductHeadGenericLabel } from '../ProductHead/ProductHeadLabels/ProductHeadGenericLabel/ProductHeadGenericLabel'

import { useGenerateVolumePricingBadgeData } from './useGenerateVolumePricingBadgeData'

type ProductPageVolumePricingBadgeProps = {
  className?: string
}
export const ProductPageVolumePricingBadge: FC<
  ProductPageVolumePricingBadgeProps
> = ({ className }) => {
  const { discount, discountActivated, quantity } =
    useGenerateVolumePricingBadgeData()
  const { openableControls } = useProductVolumePricingContext()
  const isMarketplaceHarmonisationEnabled =
    useGetExperiment(EXPERIMENT_NAME_MARKETPLACE_HARMONISATION_PDP).variant !==
    EXPERIMENT_VARIATION.DEFAULT

  if (!discount || !quantity) {
    return null
  }

  return (
    <>
      <ProductVolumePricingModal />
      <ProductHeadGenericLabel
        className={clsx(
          'flex w-fit flex-nowrap items-center justify-center gap-1 rounded-full border-none p-2 text-xs text-dark-primary-max',
          isMarketplaceHarmonisationEnabled
            ? 'bg-light-tertiary'
            : 'bg-light-brand-high',
          className,
        )}
        onClick={openableControls.handleOpen}
        type="button"
      >
        {discountActivated ? (
          <FormattedMessage
            id="volumePricing.pdp.label.maxDiscount.text"
            values={{
              discount,
            }}
          />
        ) : (
          <FormattedMessage
            id="volumePricing.pdp.label.text"
            values={{
              discount,
              quantity,
            }}
          />
        )}

        <IconInfo className="size-4" />
      </ProductHeadGenericLabel>
    </>
  )
}
